import BurgerModel from './Components/BurgerModel';
import { softShadows } from '@react-three/drei';

softShadows()

function App() {
softShadows()

  return (
    <div className="App">
      <BurgerModel />
    </div>
  );
}

export default App;
